"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _useFetch5 = _interopRequireDefault(require("../Store/useFetch"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant = require("./constant");

var _calendar = _interopRequireDefault(require("./calendar.proptypes"));

var _calendar2 = require("./calendar.utilities");

var _calendarheader = _interopRequireDefault(require("./calendar-header/calendarheader"));

var _calendarbody = _interopRequireDefault(require("./calendar-body/calendarbody"));

var _calendarfooter = _interopRequireDefault(require("./calendar-footer/calendarfooter"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CloseCalendar = _styledComponents.default.div.withConfig({
  displayName: "Calendar__CloseCalendar",
  componentId: "sc-6f6x0c-0"
})(["position:fixed;top:", ";left:", ";right:", ";bottom:", ";background-color:transparent;z-index:1;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.none;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.none;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.none;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.none;
});

var CalenderContainer = _styledComponents.default.div.withConfig({
  displayName: "Calendar__CalenderContainer",
  componentId: "sc-6f6x0c-1"
})(function (_ref5) {
  var theme = _ref5.theme,
      calendarContainerShowWebTablet = _ref5.calendarContainerShowWebTablet,
      isMobileOpen = _ref5.isMobileOpen,
      isPartialHotelCalendar = _ref5.isPartialHotelCalendar;
  return "\n    display: inline-block;\n    position: relative;\n    // width: 100%;\n    right: ".concat(theme.space.none, ";\n    border-radius: ").concat(theme.borderRadius.normal, ";\n    left: ").concat(calendarContainerShowWebTablet && 0, ";\n    z-index: ").concat(isPartialHotelCalendar ? 1 : 2, ";\n\n    ").concat(isMobileOpen && "\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        z-index: 10;\n        display: flex;\n        flex-direction: column;\n      ", "\n  ");
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "Calendar__Container",
  componentId: "sc-6f6x0c-2"
})(function (_ref6) {
  var isMobile = _ref6.isMobile,
      openDirection = _ref6.openDirection;
  return "\n    width: ".concat(!isMobile ? '772px' : 'auto', ";\n\n    ").concat(isMobile ? "\n        display: flex;\n        flex: 1;\n        flex-direction: column;\n\n        & #calenderbody, #partialHotelCalendarBody{\n          flex: 1;\n        }\n      " : "\n        position: absolute;\n        top: 103%;\n        ".concat(openDirection === _constant.CALENDAR_OPEN_CALENDAR_DIRECTION.RIGHT ? "left:0;" : "right: 0;", "\n\n      "), "\n  ");
});

var Calendar = function Calendar(props) {
  var viewType = props.viewType,
      maxDays = props.maxDays,
      theme = props.theme,
      labelDepart = props.labelDepart,
      labelReturn = props.labelReturn,
      dateFormatData = props.dateFormatData,
      currencyFormatData = props.currencyFormatData,
      calendarOutputdata = props.calendarOutputdata,
      emitOutputOnlyOnConfirm = props.emitOutputOnlyOnConfirm,
      disableOneway = props.disableOneway,
      layout = props.layout,
      resetLabel = props.resetLabel,
      confirmLabel = props.confirmLabel,
      lowestFareLabel = props.lowestFareLabel,
      noFareLabel = props.noFareLabel,
      prefillDefaultDepart = props.prefillDefaultDepart,
      prefillDefaultReturn = props.prefillDefaultReturn,
      flightDepart = props.flightDepart,
      flightReturn = props.flightReturn,
      preFillTripType = props.preFillTripType,
      openCalendarModal = props.openCalendarModal,
      callbackOpenCalendarModal = props.callbackOpenCalendarModal,
      calendarDirection = props.calendarDirection,
      customProperties = props.customProperties,
      enableLFC = props.enableLFC,
      enableLFCV2 = props.enableLFCV2,
      isSnapCalendar = props.isSnapCalendar,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      environment = props.environment,
      lfcDepartEndpoint = props.lfcDepartEndpoint,
      lfcReturnEndpoint = props.lfcReturnEndpoint,
      lfcConfig = props.lfcConfig,
      prefillLfcOneWayPrice = props.prefillLfcOneWayPrice,
      prefillLfcReturnPrice = props.prefillLfcReturnPrice,
      snapLfcPrices = props.snapLfcPrices,
      customDateLabels = props.customDateLabels,
      maxRangeDays = props.maxRangeDays,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      minNights = props.minNights,
      enableAvailableDateCalendarFlag = props.enableAvailableDateCalendarFlag,
      headerInputContainerPadding = props.headerInputContainerPadding,
      resetToPrefilledDates = props.resetToPrefilledDates,
      disableDepart = props.disableDepart,
      disableReturn = props.disableReturn,
      addCalenderIconForMobile = props.addCalenderIconForMobile,
      enableFontSizeChange = props.enableFontSizeChange,
      lowestFareLabelOneWay = props.lowestFareLabelOneWay,
      lowestFareLabelDepart = props.lowestFareLabelDepart,
      lowestFareLabelReturn = props.lowestFareLabelReturn,
      holidayMobile = props.holidayMobile;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var defaultDepart = isPartialHotelCalendar || resetToPrefilledDates ? new Date(prefillDefaultDepart) : _calendar2.AaCalendarUtilities.addDaysToDate(new Date(), 7);
  var defaultReturn = disableOneway ? (isPartialHotelCalendar || resetToPrefilledDates) && new Date(prefillDefaultReturn) || _calendar2.AaCalendarUtilities.addDaysToDate(defaultDepart, 3) : null;

  var maxDate = _calendar2.AaCalendarUtilities.addDaysToDate(new Date(), maxDays);

  var isChinaDomain = _utilities.default.isChinaDomainName();

  var domain = isChinaDomain ? 'cn' : 'com';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFareLoaded = _useState2[0],
      setIsFareLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isFareLoadedV2 = _useState4[0],
      setIsFareLoadedV2 = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isSnapPricesLoaded = _useState6[0],
      setIsSnapPricesLoaded = _useState6[1];

  var _useState7 = (0, _react.useState)(disableOneway ? _constant.CALENDAR_TRIP_TYPE.RETURN : _constant.CALENDAR_TRIP_TYPE.ONEWAY),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      tripType = _useState8[0],
      setTripType = _useState8[1];

  var isPrefillValid = function isPrefillValid(dateD, dateR) {
    var validDateD = dateD && Boolean(Date.parse(dateD));
    if (!validDateD) return false;

    if (_calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(new Date(dateD), new Date()) || _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(new Date(dateD), maxDate)) {
      return false;
    }

    if (preFillTripType === _constant.TRIP_RETURN) {
      var validDateR = dateR && Boolean(Date.parse(dateR));

      if (!validDateR) {
        return false;
      }

      if (_calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(new Date(dateR), maxDate) || _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(new Date(dateR), new Date(dateD))) {
        return false;
      }
    }

    return true;
  };
  /**
   * States that will hold the Date Object for both depart/return dates.
   * These states are the one to be used as the final date output of AaCalendar
   */


  var _useState9 = (0, _react.useState)(prefillDefaultDepart && isPrefillValid(prefillDefaultDepart, prefillDefaultReturn) ? new Date(prefillDefaultDepart) : defaultDepart),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      tempDepart = _useState10[0],
      setTempDepart = _useState10[1];

  var _useState11 = (0, _react.useState)(prefillDefaultReturn && isPrefillValid(prefillDefaultDepart, prefillDefaultReturn) ? new Date(prefillDefaultReturn) : defaultReturn),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      tempReturn = _useState12[0],
      setTempReturn = _useState12[1];
  /**
   * Formatted Dates that will be displayed in depart/return text fields
   */


  var _useState13 = (0, _react.useState)(_calendar2.AaCalendarUtilities.formatDates(tempDepart)),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      departDate = _useState14[0],
      setDepartDate = _useState14[1];

  var _useState15 = (0, _react.useState)(_calendar2.AaCalendarUtilities.formatDates(tempReturn)),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      returnDate = _useState16[0],
      setReturnDate = _useState16[1];

  var _useState17 = (0, _react.useState)(_constant.DEPART_DATE),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      attribute = _useState18[0],
      setattribute = _useState18[1];
  /**
   * States to determine if the next date that will be selected
   * is for depart or for return date
   */


  var _useState19 = (0, _react.useState)(true),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      selectForDepart = _useState20[0],
      setSelectForDepart = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      selectForReturn = _useState22[0],
      setSelectForReturn = _useState22[1];

  var _useState23 = (0, _react.useState)(true),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      newInstance = _useState24[0],
      setNewInstance = _useState24[1];
  /**
   * State that determines if Calendar Widget will be
   * shown or not
   */


  var _useState25 = (0, _react.useState)(false),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      showCalendarModal = _useState26[0],
      setShowCalendarModal = _useState26[1];

  var _useState27 = (0, _react.useState)(true),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      disableButtons = _useState28[0],
      setDisableButtons = _useState28[1];

  var _useState29 = (0, _react.useState)(false),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      toReset = _useState30[0],
      setToReset = _useState30[1];

  var viewTypereceived = viewType === _constant.MOBILE ? _constant.CALENDAR_VIEW_TYPE.MOBILE : _constant.CALENDAR_VIEW_TYPE.DESKTOP;

  var _useFetch = (0, _useFetch5.default)(null, 'lfcOneWayResponse'),
      _useFetch2 = (0, _slicedToArray2.default)(_useFetch, 1),
      lfcOneWayResponse = _useFetch2[0];

  var _useFetch3 = (0, _useFetch5.default)(null, 'lfcReturnResponse'),
      _useFetch4 = (0, _slicedToArray2.default)(_useFetch3, 1),
      lfcReturnResponse = _useFetch4[0];

  var _useState31 = (0, _react.useState)(maxRangeDays),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      maxReturnDays = _useState32[0],
      setMaxReturnDays = _useState32[1];
  /**
   * Final output state of AaCalendar
   */


  var _useState33 = (0, _react.useState)({
    // eslint-disable-next-line object-shorthand
    tripType: tripType,
    dates: {
      departureDate: tempDepart,
      returnDate: tripType === _constant.CALENDAR_TRIP_TYPE.ONEWAY ? null : tempReturn
    }
  }),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      calendarOutput = _useState34[0],
      setCalendarOutput = _useState34[1];

  var _useState35 = (0, _react.useState)(false),
      _useState36 = (0, _slicedToArray2.default)(_useState35, 2),
      firstLoadDone = _useState36[0],
      setFirstLoadDone = _useState36[1];

  (0, _react.useEffect)(function () {
    setIsSnapPricesLoaded(Boolean(snapLfcPrices));
  }, [snapLfcPrices]);
  (0, _react.useEffect)(function () {
    if (!enableLFC) {
      return;
    }

    if (prefillLfcOneWayPrice) {
      setIsFareLoaded(true);
    }
  }, [enableLFC, prefillLfcOneWayPrice, prefillLfcReturnPrice]);
  (0, _react.useEffect)(function () {
    if (!enableLFC || prefillLfcOneWayPrice || customDateLabels) {
      return;
    }

    if (!lfcOneWayResponse) {
      setIsFareLoaded(false);
      return;
    }

    if (lfcOneWayResponse.isFetching || lfcOneWayResponse.isError) {
      setIsFareLoaded(false);
      return;
    }

    setIsFareLoaded(true);
  }, [lfcOneWayResponse, enableLFC, prefillLfcOneWayPrice, customDateLabels]);
  (0, _react.useEffect)(function () {
    if (!enableLFC || customDateLabels) {
      setIsFareLoaded(false);
      return;
    }

    if (tripType === _constant.CALENDAR_TRIP_TYPE.ONEWAY) {
      return;
    }

    if (!lfcReturnResponse) {
      return;
    }

    if (lfcReturnResponse.isFetching || lfcReturnResponse.isError) {
      setIsFareLoaded(false);
      return;
    }

    setIsFareLoaded(true);
  }, [lfcReturnResponse, tripType, enableLFC, customDateLabels]);
  /**
   *
   * @param {Date} dates - Date Object from calendar selection
   *
   * Handles action needed when user selects return date
   */

  var onReturnChangeHandler = function onReturnChangeHandler(dates) {
    // eslint-disable-next-line no-shadow
    var returnDate = '';
    var returnDateObj = dates || null;

    if (returnDateObj) {
      returnDate = _calendar2.AaCalendarUtilities.formatDates(returnDateObj);
    }

    setReturnDate(returnDate);
    setTempReturn(dates);
    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        departureDate: calendarOutput.dates.departureDate,
        returnDate: returnDateObj
      }
    }));
    setToReset(false);
  };
  /**
   *
   * @param {string} departDate - date string
   * @param {string} returnDate - date string
   *
   * Checks if `Confirm` and `Reset` buttons will be enabled/disabled
   */
  // eslint-disable-next-line no-shadow


  var checkButtonState = (0, _react.useCallback)(function (departDate, returnDate) {
    if (tripType === _constant.CALENDAR_TRIP_TYPE.ONEWAY && departDate && departDate !== '') {
      return false;
    }

    if (tripType === _constant.CALENDAR_TRIP_TYPE.RETURN && departDate && departDate !== '' && returnDate && returnDate !== '') {
      return false;
    }

    return true;
  });
  /**
   *
   * @param {number} type - date selection type, values can be 1 for oneway, 2 for return
   *
   * Determines if the next date selection is for depart or for return
   */

  var toggleDateSelectionHandler = function toggleDateSelectionHandler(type) {
    if (type === _constant.TOGGLE_DATE_SELECTION.DEPART) {
      setSelectForDepart(true);
      setSelectForReturn(false);
    } else if (type === _constant.TOGGLE_DATE_SELECTION.RETURN) {
      setSelectForDepart(false);
      setSelectForReturn(true);
      setNewInstance(false);
    }
  };
  /**
   * Determines the status of `Clear` and `Done` buttons of calendar widget
   * based on values of `departDate`, `returnDate`, and `tripType`.
   *
   * Enable these buttons if the values are not null, otherwise, disable them
   */


  (0, _react.useEffect)(function () {
    setDisableButtons(checkButtonState(departDate, returnDate));
  }, [checkButtonState, departDate, returnDate, tripType]); // HANDLERS

  var onFocusDepart = function onFocusDepart() {
    if (isPartialHotelCalendar) {
      var partialHotelCalendar = document.querySelector('#partialHotelBodyContainer');

      if (!partialHotelCalendar) {
        document.querySelector('#partialHotel-departclick-handle input').blur();
      }
    } else {
      var flightCalendar = document.querySelector('#bodyContainer');

      if (!flightCalendar) {
        document.querySelector('#departclick-handle input').blur();
      }
    }

    setattribute(_constant.DEPART_DATE);
    toggleDateSelectionHandler(_constant.TOGGLE_DATE_SELECTION.DEPART);
    setNewInstance(true);
    setShowCalendarModal(true);
  };

  var onFocusReturn = function onFocusReturn() {
    if (isPartialHotelCalendar) {
      var partialHotelCalendar = document.querySelector('#partialHotelBodyContainer');

      if (!partialHotelCalendar) {
        document.querySelector('#partialHotel-returnclick-handle input').blur();
      }
    } else {
      var flightCalendar = document.querySelector('#bodyContainer');

      if (!flightCalendar) {
        document.querySelector('#returnclick-handle input').blur();
      }
    }

    setattribute(_constant.RETURN_DATE);
    toggleDateSelectionHandler(_constant.TOGGLE_DATE_SELECTION.RETURN);
    setShowCalendarModal(true);
  };

  var onCalendarBlur = function onCalendarBlur() {
    setShowCalendarModal(false);
  };
  /**
   *
   * @param {Date} dates - Date Object from calendar selection
   *
   * Handles action needed when user selects depart date
   */


  var onDepartChangeHandler = function onDepartChangeHandler(dates) {
    // eslint-disable-next-line no-shadow
    var departDate = '';
    var departDateObj = dates || null;

    if (departDateObj) {
      departDate = _calendar2.AaCalendarUtilities.formatDates(departDateObj);
    }

    setDepartDate(departDate);
    setTempDepart(dates);

    if (maxRangeDays) {
      var maxReturnDate = _calendar2.AaCalendarUtilities.addDaysToDate(departDateObj, maxRangeDays);

      var nextMaxReturnDays = Math.min(_calendar2.AaCalendarUtilities.dayDifference(new Date(), maxReturnDate), maxDays);
      setMaxReturnDays(nextMaxReturnDays);
      var currentReturnDate = calendarOutput.dates.returnDate;
      var isAfterMaxDate = currentReturnDate ? _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(currentReturnDate, maxReturnDate) : false;

      if (isAfterMaxDate) {
        onReturnChangeHandler(maxReturnDate);
      }
    }

    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        departureDate: departDateObj,
        returnDate: calendarOutput.dates.returnDate
      }
    }));
    setToReset(false);
  };

  (0, _react.useEffect)(function () {
    if (!isPartialHotelCalendar && (!maxRangeDays || typeof prefillDefaultDepart === 'string')) {
      return;
    }

    var receivedDepart = prefillDefaultDepart;
    var receivedReturn = prefillDefaultReturn;

    var validDepart = _calendar2.AaCalendarUtilities.isValidDate(receivedDepart);

    var validReturn = _calendar2.AaCalendarUtilities.isValidDate(receivedReturn);

    var finalDepart = defaultDepart;
    var finalReturn = defaultReturn;

    if (!validDepart && !validReturn) {
      return;
    }

    if (validDepart) {
      var isBeforeToday = _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(receivedDepart, new Date());

      var isAfterMaxDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(receivedDepart, maxDate);

      if (!(isBeforeToday || isAfterMaxDate)) {
        finalDepart = receivedDepart;
      }
    }

    onDepartChangeHandler(finalDepart);
    finalReturn = _calendar2.AaCalendarUtilities.addDaysToDate(finalDepart, _constant.DEFAULT_OFFSET.RANGE);

    if (validReturn) {
      var maxRangeDate = _calendar2.AaCalendarUtilities.addDaysToDate(finalDepart, maxRangeDays);

      var isAfterMaxRangeDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(receivedReturn, maxRangeDate);

      var _isAfterMaxDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(receivedReturn, maxDate);

      var isBeforeDepartDate = _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(receivedReturn, finalDepart);

      var isInMaxRange = !(isAfterMaxRangeDate || _isAfterMaxDate);

      if (isInMaxRange && !isBeforeDepartDate) {
        finalReturn = receivedReturn;
      }
    }

    onReturnChangeHandler(finalReturn);
    var didDepartChange = finalDepart !== receivedDepart;
    var didReturnChange = finalReturn !== receivedReturn;

    if (didDepartChange || didReturnChange) {
      setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
        dates: {
          departureDate: finalDepart,
          returnDate: finalReturn
        }
      }));
    }
  }, [maxRangeDays, prefillDefaultDepart, prefillDefaultReturn, isPartialHotelCalendar]);
  /**
   * Outputs the selected trip type, depart and return dates.
   * Do necessary adjustments when user doesn't select depart or return date
   */

  (0, _react.useEffect)(function () {
    if (prefillDefaultDepart && isPrefillValid(prefillDefaultDepart, prefillDefaultReturn)) {
      setTempDepart(new Date(prefillDefaultDepart));
    }

    if (prefillDefaultReturn && isPrefillValid(prefillDefaultDepart, prefillDefaultReturn)) {
      setTempReturn(new Date(prefillDefaultReturn));
    }
  }, [prefillDefaultDepart, prefillDefaultReturn]);

  var onDonePress = function onDonePress() {
    var departHolder = tempDepart;
    var returnHolder = tempReturn;
    setShowCalendarModal(false);
    if (callbackOpenCalendarModal) callbackOpenCalendarModal(false);
    setNewInstance(true);

    if (!departDate) {
      onDepartChangeHandler(tempDepart);
    }

    if (!tempDepart) {
      departHolder = defaultDepart;
    }

    if ((!returnDate || _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(tempReturn, tempDepart)) && tripType === _constant.CALENDAR_TRIP_TYPE.RETURN) {
      if (isPartialHotelCalendar) {
        departHolder = defaultDepart;
        returnHolder = defaultReturn;
        onDepartChangeHandler(departHolder);
      } else {
        returnHolder = _calendar2.AaCalendarUtilities.addDaysToDate(tempDepart, 3);
      }

      onReturnChangeHandler(returnHolder);
    }

    if (!tempDepart && tripType === _constant.CALENDAR_TRIP_TYPE.ONEWAY) {
      setDepartDate(_calendar2.AaCalendarUtilities.formatDates(defaultDepart));
      setTempDepart(defaultDepart); // navin--> tells parent the date selected

      calendarOutputdata({
        // eslint-disable-next-line object-shorthand
        tripType: tripType,
        dates: {
          departureDate: defaultDepart,
          returnDate: null
        }
      });
      return;
    }

    if (!tempDepart && !tempReturn && tripType === _constant.CALENDAR_TRIP_TYPE.RETURN) {
      setDepartDate(_calendar2.AaCalendarUtilities.formatDates(defaultDepart));
      setReturnDate(_calendar2.AaCalendarUtilities.formatDates(defaultReturn));
      setTempDepart(defaultDepart);
      setTempReturn(defaultReturn);
      calendarOutputdata({
        // eslint-disable-next-line object-shorthand
        tripType: tripType,
        dates: {
          departureDate: defaultDepart,
          returnDate: defaultReturn
        }
      });
      return;
    }

    calendarOutputdata({
      // eslint-disable-next-line object-shorthand
      tripType: tripType,
      dates: {
        departureDate: departHolder,
        returnDate: returnHolder
      }
    });
    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        departureDate: departHolder,
        returnDate: returnHolder
      }
    }));
  };
  /**
   *
   * @param {string} attr - name/identifier of text field
   * @param {string} val - value from text field
   *
   * Sets depart or return date based on user input in depart/return text fields
   */


  var onValueChange = function onValueChange(val) {
    var attr = attribute;
    var newValue = val.target.value;

    if (attr === _constant.DEPART_DATE) {
      setDepartDate(newValue);
    }

    if (attr === _constant.RETURN_DATE) {
      setReturnDate(newValue);
    }

    if (newValue.length < 10) {
      return;
    }

    if (attr === _constant.DEPART_DATE) {
      var inputDate = _calendar2.AaCalendarUtilities.formatDateInputFormat(newValue);

      if (inputDate) {
        var newDate = new Date(inputDate);

        var beyondMaxDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(newDate, maxDate);

        var previousOfStartDate = _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(newDate, new Date());

        var previousOfFlightDate = isPartialHotelCalendar && _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(newDate, defaultDepart);

        var beyondFlightDate = isPartialHotelCalendar && _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(newDate, defaultReturn);

        var numberOfNights = _calendar2.AaCalendarUtilities.dayDifference(newDate, tempReturn);

        if (beyondMaxDate || previousOfStartDate || previousOfFlightDate || beyondFlightDate || isPartialHotelCalendar && numberOfNights < minNights) {
          setDepartDate(_calendar2.AaCalendarUtilities.formatDates(tempDepart));
          return;
        }

        onDepartChangeHandler(newDate);

        var beyondReturnDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(newDate, tempReturn);

        if (!beyondReturnDate) {
          return;
        }

        onReturnChangeHandler(null);
      } else {
        setDepartDate(_calendar2.AaCalendarUtilities.formatDates(tempDepart));
      }
    }

    if (attr === _constant.RETURN_DATE) {
      setReturnDate(newValue);

      var _inputDate = _calendar2.AaCalendarUtilities.formatDateInputFormat(newValue);

      if (_inputDate) {
        var _newDate = new Date(_inputDate);

        var _beyondMaxDate = _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(_newDate, maxDate);

        var onOrBeforeDepartDate = _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate(_newDate, tempDepart);

        var _numberOfNights = _calendar2.AaCalendarUtilities.dayDifference(tempDepart, _newDate);

        var _previousOfFlightDate = isPartialHotelCalendar && _calendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(_newDate, defaultDepart);

        var _beyondFlightDate = isPartialHotelCalendar && _calendar2.AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(_newDate, defaultReturn);

        if (_beyondMaxDate || isSnapCalendar && onOrBeforeDepartDate || _beyondFlightDate || _previousOfFlightDate || isPartialHotelCalendar && _numberOfNights < minNights) {
          setReturnDate(_calendar2.AaCalendarUtilities.formatDates(tempReturn));
          return;
        }

        onReturnChangeHandler(_newDate);
      } else {
        setReturnDate(_calendar2.AaCalendarUtilities.formatDates(tempReturn));
      }
    }
  };
  /**
   * Actions to be done when user press `Reset` button
   */


  var onResetHandler = function onResetHandler() {
    setTempDepart(defaultDepart);

    if (tripType === _constant.CALENDAR_TRIP_TYPE.RETURN) {
      setTempReturn(defaultReturn);
      setReturnDate(_calendar2.AaCalendarUtilities.formatDates(defaultReturn));
    } else {
      setTempReturn(null);
      setReturnDate(_calendar2.AaCalendarUtilities.formatDates(''));
    }

    setDepartDate(_calendar2.AaCalendarUtilities.formatDates(defaultDepart));
    setToReset(true);

    if (viewType === _constant.MOBILE && typeof document !== 'undefined') {
      var id = isPartialHotelCalendar ? '#partialHotelMobileScroll-container' : '#mobileScroll-container';
      var mobileScrollContainer = document.querySelector(id);

      if (mobileScrollContainer && !resetToPrefilledDates) {
        mobileScrollContainer.scrollTop = 0;
      }

      if (resetToPrefilledDates) {
        var selector = isPartialHotelCalendar ? "#partialHotelCalendar-instance-".concat(defaultDepart.getMonth(), "-").concat(defaultDepart.getFullYear()) : "#calendar-instance-".concat(defaultDepart.getMonth(), "-").concat(defaultDepart.getFullYear());
        var element = document.querySelector(selector);
        if (element) element.scrollIntoView();
      }
    }

    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        departureDate: defaultDepart,
        returnDate: defaultReturn
      }
    }));
  };
  /**
   * Call `onDonePress` method when user press `Confirm` button
   */


  var onConfirmHandler = function onConfirmHandler() {
    onDonePress();
  };

  (0, _react.useEffect)(function () {
    if (firstLoadDone) {
      if (disableOneway) {
        setTripType(_constant.TRIP_RETURN);
      } else {
        setTripType(_constant.TRIP_ONEWAY);
      }

      setReturnDate('');
      setTempReturn(null);

      if (!disableOneway) {
        setCalendarOutput({
          tripType: _constant.TRIP_ONEWAY,
          dates: {
            departureDate: calendarOutput.dates.departureDate,
            returnDate: null
          }
        });

        if (!emitOutputOnlyOnConfirm) {
          calendarOutputdata({
            tripType: _constant.TRIP_ONEWAY,
            dates: {
              departureDate: calendarOutput.dates.departureDate,
              returnDate: null
            }
          });
        }

        toggleDateSelectionHandler(_constant.TOGGLE_DATE_SELECTION.DEPART);
        setNewInstance(true);
      } else {
        setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
          tripType: _constant.TRIP_RETURN
        }));

        if (!emitOutputOnlyOnConfirm) {
          calendarOutputdata(_objectSpread(_objectSpread({}, calendarOutput), {}, {
            tripType: _constant.TRIP_RETURN
          }));
        }

        if (tempDepart && !tempReturn) {
          toggleDateSelectionHandler(_constant.TOGGLE_DATE_SELECTION.RETURN);
        }
      }
    }

    if (!firstLoadDone && !isOnlyApplyForHotel && !emitOutputOnlyOnConfirm) {
      calendarOutputdata(calendarOutput);
    }

    setFirstLoadDone(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableOneway]);
  /**
   * Configuration object for depart text field
   */

  var textDepartInputConfig = {
    controls: {
      attrName: _constant.DEPART_DATE,
      value: departDate,
      updateMasterState: onValueChange,
      onInputFocus: disableDepart ? null : onFocusDepart,
      weekDays: _constant.WEEKDAYS_OBJ,
      selectTextOnFocus: true
    }
  };
  /**
   * Configuration object for return text field
   */

  var textReturnInputConfig = {
    controls: {
      attrName: _constant.RETURN_DATE,
      value: returnDate,
      updateMasterState: onValueChange,
      onInputFocus: disableReturn ? null : onFocusReturn,
      selectTextOnFocus: true
    }
  };
  /**
   * Configuration object for Confirm and Reset buttons
   */

  var hotelButtonCfg = {
    reset: {
      controls: {
        onButtonPress: onResetHandler
      }
    },
    confirm: {
      style: {
        backgroundColor: 'primary'
      },
      controls: {
        onButtonPress: onConfirmHandler
      }
    }
  };
  var buttonsConfig = isOnlyApplyForHotel ? hotelButtonCfg : {
    reset: {
      controls: {
        onButtonPress: onResetHandler
      }
    },
    confirm: {
      controls: {
        onButtonPress: onConfirmHandler
      }
    }
  };
  /**
   * Configuration object for calendar widget
   */

  var calendarModalConfig = {
    controls: {
      onDepartChange: onDepartChangeHandler,
      onReturnChange: onReturnChangeHandler,
      selectionType: tripType === _constant.CALENDAR_TRIP_TYPE.RETURN ? _constant.CALENDAR_SELECTION_TYPE.TWO : _constant.CALENDAR_SELECTION_TYPE.ONE,
      maxDays: !selectForDepart && maxRangeDays ? maxReturnDays : maxDays,
      viewType: viewTypereceived,
      toggleDateSelection: toggleDateSelectionHandler
    }
  };
  /**
   *
   * @param {string} format - date format
   *
   * Change date string format in depart/return text fields based on provided `format`
   */

  var setTextInputDateFormat = (0, _react.useCallback)(function (format) {
    setDepartDate(_calendar2.AaCalendarUtilities.formatDates(tempDepart, format));
    setReturnDate(_calendar2.AaCalendarUtilities.formatDates(tempReturn, format));
  }, [tempDepart, tempReturn]);
  var getDateDataFormat = (0, _react.useCallback)(function (Data) {
    _calendar2.AaCalendarUtilities.setDateFormat(Data);

    setTextInputDateFormat(Data.date.general);
  }, [setTextInputDateFormat]);
  /**
   * Call `dataformat/date` endpoint through `getDateDataFormat` method whenever
   * locale change
   */

  (0, _react.useEffect)(function () {
    getDateDataFormat(dateFormatData);
  }, [dateFormatData, getDateDataFormat]);
  (0, _react.useEffect)(function () {
    if (!isPartialHotelCalendar) {
      _calendar2.AaCalendarUtilities.setCurrencyFormat(currencyFormatData);
    }
  }, [currencyFormatData, isPartialHotelCalendar]);

  var closeCalendar = function closeCalendar() {
    setShowCalendarModal(false);
    if (!emitOutputOnlyOnConfirm) onDonePress();
    if (callbackOpenCalendarModal) callbackOpenCalendarModal(false);
  };

  (0, _react.useEffect)(function () {
    setShowCalendarModal(openCalendarModal); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCalendarModal]);

  var getMain = function getMain() {
    var baseCurrency = lfcConfig.baseCurrency,
        currency = lfcConfig.currency;
    return /*#__PURE__*/_react.default.createElement("div", customProperties, showCalendarModal && /*#__PURE__*/_react.default.createElement(CloseCalendar, {
      onClick: closeCalendar
    }), /*#__PURE__*/_react.default.createElement(CalenderContainer, {
      id: showCalendarModal ? isPartialHotelCalendar && 'fsw-partial-hotel-calendar-web' || 'fsw-calendar-web' : 'fsw',
      calendarContainerShow: showCalendarModal,
      calendarContainerShowWebTablet: showCalendarModal && layout && layout.isTablet,
      isMobileOpen: Boolean(showCalendarModal && viewType === _constant.MOBILE),
      isPartialHotelCalendar: isPartialHotelCalendar,
      addCalenderIconForMobile: addCalenderIconForMobile
    }, /*#__PURE__*/_react.default.createElement(_calendarheader.default, {
      isSnapCalendar: isSnapCalendar,
      layout: viewType,
      viewType: viewType,
      showCalendarModal: showCalendarModal,
      newInstance: newInstance,
      selectForDepart: selectForDepart,
      selectForReturn: selectForReturn,
      tripType: tripType,
      tempDepart: tempDepart,
      tempReturn: tempReturn,
      labelReturn: labelReturn,
      dateFormatData: dateFormatData,
      labelDepart: labelDepart,
      textDepartInputConfig: textDepartInputConfig,
      textReturnInputConfig: textReturnInputConfig,
      closeCalendarIconPressed: closeCalendar,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      theme: theme,
      isPartialHotelCalendar: isPartialHotelCalendar,
      headerInputContainerPadding: headerInputContainerPadding,
      disableDepart: disableDepart,
      disableReturn: disableReturn,
      addCalenderIconForMobile: addCalenderIconForMobile,
      enableFontSizeChange: enableFontSizeChange,
      holidayMobile: holidayMobile
    }), showCalendarModal && /*#__PURE__*/_react.default.createElement(Container, {
      id: isPartialHotelCalendar && 'partialHotelBodyContainer' || 'bodyContainer',
      openDirection: calendarDirection,
      isMobile: viewType === _constant.MOBILE,
      addCalenderIconForMobile: addCalenderIconForMobile
    }, /*#__PURE__*/_react.default.createElement(_calendarbody.default, {
      calendarModalConfig: calendarModalConfig,
      toReset: toReset,
      resetToPrefilledDates: resetToPrefilledDates,
      showCalendarModal: showCalendarModal,
      selectForDepart: selectForDepart,
      selectForReturn: selectForReturn,
      dateFormatData: dateFormatData,
      tempDepart: tempDepart,
      tempReturn: tempReturn,
      lfcConfig: lfcConfig,
      enableLFC: enableLFC,
      isSnapCalendar: isSnapCalendar,
      isPartialHotelCalendar: isPartialHotelCalendar,
      flightDepart: flightDepart,
      flightReturn: flightReturn,
      minNights: minNights,
      environment: environment,
      lfcDepartEndpoint: lfcDepartEndpoint,
      lfcReturnEndpoint: lfcReturnEndpoint,
      currencyFormatData: currencyFormatData,
      prefillLfcOneWayPrice: prefillLfcOneWayPrice,
      prefillLfcReturnPrice: prefillLfcReturnPrice,
      customDateLabels: customDateLabels,
      theme: theme,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      snapLfcPrices: snapLfcPrices,
      enableAvailableDateCalendarFlag: enableAvailableDateCalendarFlag,
      enableLFCV2: enableLFCV2,
      setIsFareLoadedV2: setIsFareLoadedV2,
      domain: domain
    }), /*#__PURE__*/_react.default.createElement(_calendarfooter.default, {
      id: "home_return",
      viewType: viewType,
      disableButtons: disableButtons,
      buttonsConfig: buttonsConfig,
      confirmLabel: confirmLabel,
      resetLabel: resetLabel,
      lowestFareLabel: lowestFareLabel,
      noFareLabel: noFareLabel,
      currency: isSnapCalendar ? baseCurrency : currency,
      isFareLoaded: isSnapCalendar ? isSnapPricesLoaded : isFareLoaded,
      isFareLoadedV2: isFareLoadedV2,
      theme: theme,
      onBlur: onCalendarBlur,
      isPartialHotelCalendar: isPartialHotelCalendar,
      tripType: tripType,
      selectForDepart: selectForDepart,
      selectForReturn: selectForReturn,
      lowestFareLabelOneWay: lowestFareLabelOneWay,
      lowestFareLabelDepart: lowestFareLabelDepart,
      lowestFareLabelReturn: lowestFareLabelReturn
    }))));
  };

  getMain.propTypes = _calendar.default.PropTypes;
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Calendar.propTypes = _calendar.default.PropTypes;
Calendar.defaultProps = _calendar.default.DefaultProps;
var _default = Calendar;
exports.default = _default;